/* eslint-disable react/jsx-props-no-spreading */
import { forwardRef, Ref } from 'react';
import { TooltipBubble } from '../TooltipBubble';
import { TagProps } from './tag';
import { TagContainer } from './tag.styled';

const Tag = forwardRef((
  props: TagProps,
  ref: Ref<HTMLDivElement>,
) => {
  const {
    text, Icon, tagInfo, ...otherProps
  } = props;

  const tooltipDisabled = !tagInfo;

  const tagContainer = (
    <TagContainer
      ref={ ref }
      { ...otherProps }
    >
      { Icon && <Icon /> }
      {text}
    </TagContainer>
  );

  if (tooltipDisabled) {
    return tagContainer;
  }

  return (
    <TooltipBubble
      title={ tagInfo }
      placement="bottom"
      enterNextDelay={ 500 }
      enterDelay={ 500 }
    >
      { tagContainer }
    </TooltipBubble>
  );
});

Tag.displayName = 'Tag';

export default Tag;
